import React from 'react'
import Routes from './app/routes/Routes'

const App = () => {
  return (
      <Routes/>
    )
}

export default App
